@let executionForm = form();

@if (campaignStart() || campaignEnd()) {
  <p class="text-base mb-3">
    @if (campaignStart() && campaignEnd()) {
      <span class="font-normal">
        {{ 'dialogs.createCampaignDialog.briefWizard.executionStep.campaignDuration' | translate }}
      </span>
      <span class="font-bold">
        {{ campaignStart() | date: 'dd.MM.yyyy HH:mm' }} - {{ campaignEnd() | date: 'dd.MM.yyyy HH:mm' }}
      </span>
    } @else if (campaignStart()) {
      <span class="font-normal">
        {{ 'dialogs.createCampaignDialog.briefWizard.executionStep.campaignStarts' | translate }}
      </span>
      <span class="font-bold">{{ campaignStart() | date: 'dd.MM.yyyy HH:mm' }}</span>
    } @else {
      <span class="font-normal">
        {{ 'dialogs.createCampaignDialog.briefWizard.executionStep.campaignEnds' | translate }}
      </span>
      <span class="font-bold">{{ campaignEnd() | date: 'dd.MM.yyyy HH:mm' }}</span>
    }
  </p>
}

@if (gamePlaysDuration()) {
  <p class="text-base mb-3">
    {{
      'dialogs.createCampaignDialog.briefWizard.executionStep.gamePlaysDuration'
        | translate: { duration: gamePlaysDuration() }
    }}
  </p>
}

@if (executionForm) {
  <app-execution
    [form]="executionForm"
    [platformFeature]="platformFeature()!"
    [availableKpis]="null"
    [gamePlayValues]="[]"
    [creatorId]="null"
    [isCustomMode]="false"
    [creators]="[]"
    [isParentDeleteDisabled]="true"
    [isExpanded]="true"
  />
}
